import { extend } from 'vee-validate';

type YoutubeTagValidationParams = {
    max: string;
    words_per_tag: string;
    max_tags: string;
};

extend('youtube_tags', {
    params: ['max', 'max_tags', 'words_per_tag'],
    validate(value: string[], params) {
        if (!value.length) {
            return true;
        }

        const { max, words_per_tag, max_tags } =
            params as YoutubeTagValidationParams;

        return (
            value.join(',').length <= Number(max) &&
            value.length <= Number(max_tags) &&
            value.every(v => {
                return (
                    v.split(' ').filter(Boolean).length <= Number(words_per_tag)
                );
            })
        );
    },
    message: `Tags must not exceed {max_tags} tags, {words_per_tag} words per tag, and {max} characters in total.`
});
